exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".td-acciones[data-v-b6e3498c]{text-align:right}@media (max-width:767px){.td-acciones[data-v-b6e3498c]{text-align:center}.td-data[data-v-b6e3498c]{vertical-align:middle!important}}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/views/reportes-media/TablaReporteMedia.vue"],"names":[],"mappings":"AACA,8BACI,gBAAkB,CACrB,AACD,yBACA,8BACI,iBAAmB,CACtB,AACD,0BACI,+BAAiC,CACpC,CACA","file":"TablaReporteMedia.vue","sourcesContent":["\n.td-acciones[data-v-b6e3498c] {\n    text-align: right;\n}\n@media (max-width: 767px) {\n.td-acciones[data-v-b6e3498c] {\n    text-align: center;\n}\n.td-data[data-v-b6e3498c] {\n    vertical-align: middle!important;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b6e3498c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/reportes-media/TablaReporteMedia.vue
// module id = 384
// module chunks = 0